import axios from 'axios';
import { showAppLoader, hideAppLoader } from '../app';

export const downloadFile = (source, linkUrl, token, apiType) => (dispatch) => {
  const fileUrl = linkUrl ? linkUrl : process.env.REACT_APP_API_URL + "/order/image/" + source;
  const headers = { Authorization: token, ...(apiType === 'ptplus' && { UserType: 'internal' }), };
  dispatch(showAppLoader())
  axios({
    url: fileUrl,
    method: 'GET',
    responseType: 'blob',
    headers
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = source; // specify the desired file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    dispatch(hideAppLoader());
  }).catch(error => {
    console.error('Error fetching file:', error);
    dispatch(hideAppLoader());
  })
};